import React from "react";
import CardText from "./CardText";
import ChallengingDesign from "./ChallengingDesign";
import Testimonials from "./Testimonials";
import Brands from "./Brands";
import Stats from "./Stats";
import RecentProjects from "./RecentProjects";
import RecentBlogs from "./Blogs";

function AboutUs() {
  return (
    <>
      <CardText />
      <ChallengingDesign />
      <Testimonials />
      <Brands />
      <RecentProjects />
      <Stats />
      <RecentBlogs />
    </>
  );
}

export default AboutUs;
